import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const initialState = {
  orgTree: null,
  spList: null,
  siList: null,
};

const adminPageContextSlice = createSlice({
  name: 'adminPageContext',
  initialState,
  reducers: {
    cleanAll(state) {
      Object.assign(state, initialState)
    },
    setAll(state, action) {
      Object.assign(state, action.payload);
    },
   },
  extraReducers: {
  }
});

export const adminPageContextActions = adminPageContextSlice.actions;

export default adminPageContextSlice;